import React from 'react';
import PropTypes from 'prop-types';

import SpinButton from './SpinButton';

import s from './RoundedIconButton.scss';

function getImage(icon) {
  if (typeof icon === 'string') {
    return (<img role="presentation" src={icon} styleName="image" />);
  }

  return icon;
}

export default function RoundedIconButton({
  children,
  className,
  icon,
  text,
  ...baseButtonProps
}) {
  return (
    <SpinButton
      className={`${className || ''} ${s.icon_button}`}
      {...baseButtonProps}
    >
      { getImage(icon) }
      <p styleName="text">{ children || text }</p>
    </SpinButton>
  );
}

RoundedIconButton.propTypes = {
  ...SpinButton.propTypes,
  children: PropTypes.node,
  icon: PropTypes.node.isRequired,
  text: PropTypes.string
};

RoundedIconButton.defaultProps = {
  ...SpinButton.defaultProps,
  children: null,
  text: null
};
